import type { KickbackReportSource } from "@KassaroAB/shared/types/enums/KickbackSource";
import type {
  RestKickbackPeriodOverview,
  RestKickbackSourceReport,
  RestSetKickbackCompanyMatch,
} from "@KassaroAB/shared/types/invoices/kickback";
import { api, apiFetchFormData } from "../utils/api";

export const getKickbackPeriodApi = async (period: string) => {
  return api.get<RestKickbackPeriodOverview>(`admin/kickbacks/${period}`);
};

export const calculateVivaKickbackApi = async (period: string, refresh: boolean) => {
  return api.post<RestKickbackSourceReport>(`admin/kickbacks/${period}/viva`, { refresh });
};

export const uploadKickbackReportApi = async (
  period: string,
  source: KickbackReportSource,
  file: File
) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiFetchFormData(`admin/kickbacks/${period}/reports/${source}`, {
    method: "POST",
    body: formData,
  }) as Promise<RestKickbackSourceReport>;
};

export const setKickbackCompanyMatchApi = async (
  period: string,
  match: RestSetKickbackCompanyMatch
) => {
  return api.put<RestKickbackSourceReport>(`admin/kickbacks/${period}/matches`, match);
};
